import React from 'react';

const ModalHeader = ({ onRequestClose }) => (
  <div className="flex justify-between items-center border-b border-gray-700 pb-4 mb-4">
    <h2 className="text-2xl md:text-3xl font-extrabold text-white tracking-wide">
      Operaciones, Pagos, Señas y Gift Cards de Hoy
    </h2>
    <button
      onClick={onRequestClose}
      className="text-gray-400 hover:text-red-500 transition-transform transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-red-500 rounded-full"
      aria-label="Cerrar modal"
    >
      <svg
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </button>
  </div>
);

export default ModalHeader;
